import Vue from 'vue'

const app = {
    state: {
        profileSelected: false,
        cguStatus: false,
        otherValue: false,
        currentQuestionId: false,
        answerSelected: false,
        profiles: [
            {
                node: {
                    image: false,
                    title: "Dermatologue",
                    body: false
                }
            },
            {
                node: {
                    image: false,
                    title: "Médecin",
                    body: false
                }
            },
            {
                node: {
                    image: false,
                    title: "Interne",
                    body: false
                }
            },
            {
                node: {
                    image: false,
                    title: "Autre",
                    body: false
                }
            }
        ],
        isModalContactVisible: false,
        previousQuestions: []
    },
    getters: {
        getProfileSelected: state => state.profileSelected,
        getCguStatus: state => state.cguStatus,
        getOtherValue: state => state.otherValue,
        getCurrentQuestionId: state => state.currentQuestionId,
        getAnswerSelected: state => state.answerSelected,
        getProfiles: state => state.profiles,
        getPreviousQuestions: state => state.previousQuestions,
        getPreviousQuestionById: (state) => (previousQuestionId) => {
            if (state.previousQuestions.length) {
                let questionFoundIndex = state.previousQuestions.findIndex(previousQuestion => previousQuestion.question.node._id === previousQuestionId)

                if (questionFoundIndex !== -1) {
                    return state.previousQuestions[questionFoundIndex].question.node
                }
            }

            return false
        },
        isModalContactVisible: (state) => state.isModalContactVisible
    },
    mutations: {
        setProfileSelected: (state, profile) => {
            state.profileSelected = profile
        },
        setCguStatus: (state, status) => {
            state.cguStatus = status
        },
        setOtherValue: (state, value) => {
            state.otherValue = value
        },
        setCurrentQuestionId: (state, value) => {
            state.currentQuestionId = value
        },
        setAnswerSelected: (state, answer) => {
            state.answerSelected = answer
            /*if (Array.isArray(answer)) {
                state.answerSelected.push(answer.value)
            } else {
                state.answerSelected = answer.value
            }*/
            // answer.push ? state.answerSelected.push(answer.value) : Vue.set(state.answerSelected, 0, answer.value)
        },
        setPreviousQuestions: (state, previousQuestions) => {
            state.previousQuestions = previousQuestions
        },
        setModalContactVisible: (state, opened) => {
            state.isModalContactVisible = opened
        }
    },
    actions: {
        setProfileSelected (context, profile) {
            context.commit('setProfileSelected', profile)
        },
        setCguStatus (context, status) {
            context.commit('setCguStatus', status)
        },
        setOtherValue (context, value) {
            context.commit('setOtherValue', value)
        },
        setCurrentQuestionId (context, value) {
            context.commit('setCurrentQuestionId', value)
        },
        setAnswerSelected (context, answer) {
            context.commit('setAnswerSelected', answer)
        },
        setPreviousQuestions (context, previousQuestions) {
            context.commit('setPreviousQuestions', previousQuestions)
        },
        setModalContactVisible (context, opened) {
            context.commit('setModalContactVisible', opened)
        }
    }
}

export default app
